import React from 'react';

const WorkflowFolderIcon = ({ height = 22, width = 22, color = 'currentColor', id = 'wf-folder', workflowColor = 'currentColor', }) => {
const maskId = `mask-${id}`;

return (
  <svg
    width={width}
    height={height}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.914 4L10.915 5H17C18.054 5 18.918 5.816 18.995 6.85L19 7V16C19 17.105 18.105 18 17 18H5C3.895 18 3 17.105 3 16V6C3 4.895 3.895 4 5 4H9.914ZM17 8H5C4.448 8 4 8.448 4 9V16C4 16.552 4.448 17 5 17H17C17.552 17 18 16.552 18 16V9C18 8.448 17.552 8 17 8ZM9.5 5H5L4.883 5.007C4.386 5.064 4 5.487 4 6V7.268C4.294 7.098 4.636 7 5 7H17C17.365 7 17.707 7.098 18.001 7.268L18 7L17.993 6.883C17.936 6.386 17.513 6 17 6H10.5L9.5 5Z"
      fill={color}
      fillOpacity="0.4"
    />
    <mask
      id={maskId}
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="3"
      y="4"
      width="16"
      height="14"
    >
      <path
        d="M9.914 4L10.915 5H17C18.054 5 18.918 5.816 18.995 6.85L19 7V16C19 17.105 18.105 18 17 18H5C3.895 18 3 17.105 3 16V6C3 4.895 3.895 4 5 4H9.914ZM17 8H5C4.448 8 4 8.448 4 9V16C4 16.552 4.448 17 5 17H17C17.552 17 18 16.552 18 16V9C18 8.448 17.552 8 17 8ZM9.5 5H5L4.883 5.007C4.386 5.064 4 5.487 4 6V7.268C4.294 7.098 4.636 7 5 7H17C17.365 7 17.707 7.098 18.001 7.268L18 7L17.993 6.883C17.936 6.386 17.513 6 17 6H10.5L9.5 5Z"
        fill="white"
      />
    </mask>

    <g mask={`url(#${maskId})`}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 16H18V17C18 17.552 17.552 18 17 18H5C4.448 18 4 17.552 4 17V16Z"
        fill={color}
        fillOpacity="0.1"
      />
    </g>

    <path
      d="M17 8C17.552 8 18 8.448 18 9V16C18 16.552 17.552 17 17 17H5C4.448 17 4 16.552 4 16V9C4 8.448 4.448 8 5 8H17Z"
      fill={color}
      fillOpacity="0.15"
    />
    <path
      d="M9.5 5L10.5 6H17C17.513 6 17.936 6.386 17.993 6.883L18 7V7.268C17.706 7.098 17.364 7 17 7H5C4.635 7 4.294 7.098 4 7.268V6C4 5.487 4.386 5.064 4.883 5.007L5 5H9.5Z"
      fill={color}
      fillOpacity="0.05"
    />
    <g opacity=".50" stroke={workflowColor} fill={workflowColor}>
      <path d="M10.1999 9.55997L10.1999 15.1597" strokeLinecap="square" />
      <path d="M8.48227 12.2997H12.7174" strokeLinecap="square" />
      <path d="M8.48228 11.7004H7V12.899H8.48228V11.7004Z" strokeLinecap="square" />
      <path d="M10.9998 9.55997H13.1174" strokeLinecap="square" />
      <path d="M14.082 9H12.5997V10.1986H14.082V9Z" strokeLinecap="square" />
      <rect x="12.8994" y="12.0195" width="0.882972" height="0.599309" strokeWidth="0.599309" />
      <path d="M14.082 11.7199H12.5997V12.9185H14.082V11.7199Z" strokeLinecap="square" />
      <path d="M10.9998 15.1597H13.1174" strokeLinecap="square" />
      <path d="M14.082 14.5997H12.5997V15.7983H14.082V14.5997Z" strokeLinecap="square" />
    </g>
  </svg>
);
};

export default WorkflowFolderIcon;